// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// eslint-disable-next-line
import Vue from 'vue';
import moment from 'moment';
import lkeComponent from '@tencent/lke-component';
import App from './App';
import Toast from '@/components/Toast';
import router from './router';
import loginRouter from './router/login';
import service from '@/utils/ajax';
import Aegis from '@tencent/aegis-web-sdk';
import Cookies from 'js-cookie';
import { isMobile, getQueryVariable, getShareCode, getUserCategory } from '@/utils/util';
import { API } from './utils/api';
import { reportQQBrowser } from './utils/reportEvent';
import mixin from '@/mixins/index.js';
import { ERROR_CODE } from './constants/error-code';
import { ChatUserCategory } from './constants';

Vue.use(lkeComponent);
const vhtml = window.vhtml;
Vue.use(vhtml);
vhtml.install(Vue);

try {
    let iconpath = 'https://cdn3.codesign.qq.com/icons/XzKaDZdEa7j2GPL/latest/iconfont.js';
    vhtml.Icon.setDefaultRemoteSrc && vhtml.Icon.setDefaultRemoteSrc(iconpath);
} catch (e) {
    console.log('load remote icon error');
}

let aegis;
if (process.env.NODE_ENV === 'production' && process.env.SERVER_ENV !== 'private') {
    // process.env.SERVER_ENV === 'prod' ?
// 处于非私有化场景下的构建模式下才会初始化 aegis，并根据不同的部署环境设置上报 id
    aegis = new Aegis({
        id: 'W7mQ8SaLJGbrgPxWgm', // 上报 id
        uin: Cookies.get('lusername') || '-', // 用户唯一 ID（可选）
        reportApiSpeed: true, // 接口测速
        reportAssetSpeed: true, // 静态资源测速
        spa: true // spa 应用页面跳转的时候开启 pv 计算
    });
}
console.log('Aegis init');
Vue.config.productionTip = false;
Vue.$aegis = aegis;
Vue.prototype.$aegis = aegis;
Vue.prototype.$ajax = service;
Vue.prototype.$toast = Toast;
Vue.prototype.moment = moment;
Vue.prototype.isMobile = isMobile();
Vue.prototype.isPhoneUser = getUserCategory() === ChatUserCategory.PHONE_NUMBER;
console.log('isMobile ==>', isMobile());
Vue.mixin(mixin);

router.beforeEach((to, from, next) => {
    document.title = to.meta.title ? `${to.meta.title} | 大模型知识引擎` : '大模型知识引擎';
    if (to.name && window.$initType !== to.name) {
    // window.location.reload();
    }
    next();
});

// 区分会话端（1-坐席端 2-用户端）
let webIMType; // 后端ws识别的端类型
let webIMSource; // 前端区分UI交互的端类型

if (window.location.href.indexOf('workbench') > -1) { // 坐席端与用户端分开，不能通过前端转跳
    webIMType = [1];
    window.$initTypeKey = 1;
    webIMSource = 'workbench';
} else if (getQueryVariable('source') === 'manage') { // 管理后台体验端
    webIMType = [3];
    window.$initTypeKey = 3;
    webIMSource = 'manage';
} else if (getQueryVariable('source') === 'workflow') { // 工作流面板的调试对话口
    webIMType = [3];
    window.$initTypeKey = 3;
    webIMSource = 'workflow';
} else if (getQueryVariable('source') === 'single') { // 工作流单节点调试，走sse
    webIMType = [4];
    window.$initTypeKey = 4;
    webIMSource = 'single';
} else { // 用户端
    webIMType = [2];
    window.$initTypeKey = 2;
    webIMSource = 'client';
    reportQQBrowser();
}

Vue.prototype.webIMSource = webIMSource;
console.log('【webIMSource】', webIMSource);

Object.defineProperty(window, 'userType', {
    writable: false,
    enumerable: false,
    configurable: false,
    value: window.location.href.indexOf('workbench') > -1 ? 1 : 2
});

window.$initType = '';
if (window.location.href.indexOf('workbench') > -1) {
    window.$initType = 'Workbench';
}
if (window.location.href.indexOf('chat') > -1) {
    window.$initType = 'Chat';
}
if (window.location.href.indexOf('login') > -1) {
    window.$initType = 'Login';
}

if (window.$initType === 'Login') { // 登录页，无需体验端token的各种初始化
    new Vue({
        el: '#app',
        router: loginRouter,
        render (h) {
            return h(App);
        }
    }).$mount('#app');
} else {
    /**
   * 登录页无需水印
   * 因此只加在对话相关页面中
   */
    window.CDSC_RTX = 'AI生成内容仅供参考';
    window.WM_CDSC_EXT = Object;
    window.WM_CDSC_EXT.cdsc_custom = '';
    window.WM_CDSC_EXT.cdsc_alpha = 0.04;
    window.WM_CDSC_EXT.cdsc_fontsize = '14px';
    window.WM_CDSC_EXT.cdsc_zoom = 1;
    window.WM_CDSC_EXT.cdsc_color = '#243861';
    window.WM_CDSC_EXT.parent_node = 'app';

    // sse不走获取token等接口
    let tokenGet = webIMType.map(type => {
        return new Promise((resolve, reject) => {
            let result = {
                type: type
            };
            const sharecode = getShareCode();
            // console.log('000000000001 webIMType----webIMSource--------》', webIMSource, sharecode);
            if (webIMSource === 'client') {
                service.post(API.GetSharePageWsToken, { ShareCode: sharecode }).then(res => {
                    result = {...result, ...res};
                    console.log('000000000001 GetSharePageWsToken--------》', res, result);
                    window.localStorage.setItem('bot_biz_id_im', res.bot_biz_id || '');
                    window.localStorage.setItem(`bot_biz_id_im_${sharecode}`, res.bot_biz_id || '');
                    window.localStorage.setItem('seat_biz_id_im', res.seat_biz_id || '');
                    window.localStorage.setItem('app_type', res.app_type || '');
                    window.localStorage.setItem('balance', res.balance || null);
                    resolve(result);
                    // GetUserDialogConfig 获取联网搜索状态 ：experience: C端体验用户，staff：腾讯云企业用户
                    // service.post(API.GetUserDialogConfig, {
                    //     user_biz_id: res.seat_biz_id,
                    //     user_type: getUserCategory() === ChatUserCategory.PHONE_NUMBER ? 'experience' : 'staff',
                    //     bot_biz_id: res.bot_biz_id }).then(ret => {
                    //     result = {...result, ...ret};
                    //     console.log('000000000001 GetSharePageWsToken---GetUserDialogConfig-----》', ret, result);
                    //     resolve(result);
                    // }).catch(e => {
                    //     console.log('000000000001 GetSharePageWsToken---GetUserDialogConfig--catch---》', e, result);
                    //     // reject(e);
                    //     resolve(result);
                    //     Vue.prototype.$message.error('获取配置信息失败');
                    // });
                }).catch(e => {
                    reject(e);
                    // 用户未登录会跳转登录页，无需弹toast
                    if (!(e.message && e.message.includes('450006'))) {
                        Vue.prototype.$message.error('获取token失败');
                    }
                });
            } else if (webIMSource === 'single') {
                let botBizId = getQueryVariable('bot_biz_id');
                console.log('【sse webim】  GetAppSecret---botBizId-----》', botBizId);
                service.post(API.GetAppSecret, {
                    app_biz_id: botBizId
                }).then(res => {
                    result = {...result, ...res};
                    console.log('【sse webim】  GetAppSecret---params--res---》', res, result);
                    resolve(result);
                }).catch(e => {
                    reject(result);
                    Vue.prototype.$message.error('获取appkey失败');
                });
            } else {
                let botBizId = getQueryVariable('bot_biz_id') || window.localStorage.getItem('bot_biz_id_im');
                if (webIMSource === 'workflow') {
                    botBizId = getQueryVariable('bot_biz_id');
                }
                console.log('000000000001 GetWsToken---params-----》', botBizId);
                service.post(API.GetWsToken, {
                    type,
                    VisitorBizId: window.localStorage.getItem('seat_biz_id_im') || getQueryVariable('seat_biz_id'),
                    BotAppKey: botBizId
                }).then(res => {
                    result.token = res.token || '';
                    result.balance = res.balance || null;
                    window.localStorage.setItem('balance', res.balance || null);
                    result = {...result, ...res};
                    console.log('000000000001 GetWsToken--------》', res, result);
                    resolve(result);
                }).catch(e => {
                    reject(result);
                    Vue.prototype.$message.error('获取token失败');
                });
            }
        });
    });

    Promise.all(tokenGet).then(res => {
        Object.defineProperty(window, 'webimToken', {
            writable: false,
            enumerable: false,
            configurable: false,
            value: res
        });
        console.log('【sse webim】  tokenGet---params-----》', res);

        Vue.prototype.INVALID_SHARECODE = false;

        if (webIMSource !== 'single') {
            (async () => {
                let mixin = await import('@/manage/index');
                Vue.mixin(mixin);
                /* eslint-disable no-new */
                new Vue({
                    el: '#app',
                    router,
                    render (h) {
                        return h(App);
                    }
                }).$mount('#app');
            })();
        } else {
            (async () => {
                let sseMixin = await import('@/manage/sse');
                Vue.mixin(sseMixin);
                /* eslint-disable no-new */
                new Vue({
                    el: '#app',
                    router,
                    render (h) {
                        return h(App);
                    }
                }).$mount('#app');
            })();
        }
    }).catch(e => {
        if (e === ERROR_CODE.INVALID_SHARECODE) {
            Vue.prototype.INVALID_SHARECODE = true;
            (async () => {
                new Vue({
                    el: '#app',
                    router,
                    render (h) {
                        return h(App);
                    }
                }).$mount('#app');
            })();
        }
    });
}



// WEBPACK FOOTER //
// ./src/main.js